export default __webpack_public_path__ + "static/media/jeongyeon.cfcfe7c4.jpg";